import React from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Women from "./category/Women";
import Community from "./category/Community";
import Disability from "./category/Disability";
import Transparency from "./category/Transparency";
import Corporate from "./category/Corporate";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import Health from "../../Category/components/category/Health";
import Climate from "../../Category/components/category/Climate";
import Solution from "../../Category/components/category/Solution";
import Civic from "../../Category/components/category/Civic";

const Categories = () => {
  const ColorButton2 = styled(Button)(() => ({
    color: "#fff",
    width: 225,
    height: 65,
    fontWeight: 700,
    fontSize: "16px",
    textTransform: "capitalize",
    marginRight: "2%",
    backgroundColor: "#004165",
    borderColor: "#004165",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#049593",
      borderColor: "#049593",
    },
  }));

  return (
    <Grid
      container
      alignItems={"center"}
      padding={{ xs: "20% 0%", sm: "4% 0%" }}
    >
      <Grid item xs={12} md={12}>
        <Box width={{ xs: "100%", sm: "40%" }}>
          <Typography
            variant="h3"
            color="#fff"
            fontWeight={800}
            paddingBottom={"4%"}
            textAlign={"center"}
          >
            <Typography
              component={"span"}
              color="#FCD18D"
              fontWeight={800}
              variant={"h3"}
            >
              Award {""}
            </Typography>
            Categories
          </Typography>
        </Box>
        <Typography
          variant={"h6"}
          fontWeight={700}
          textAlign={"center"}
          color={"#fff"}
        >
          Nomination for 2026 Active Citizens’ Awards is now open.
        </Typography>
        <Typography
          variant={"body1"}
          paddingTop={{ xs: "10%", sm: "2%" }}
          fontWeight={400}
          textAlign={"center"}
          color={"#fff"}
        >
          <strong>N.B:</strong> Your nomination is a recommendation, and our
          team will conduct further research to verify the person's work and
          credibility for the category before they can make the shortlist.
        </Typography>
        <Typography
          variant={"body2"}
          fontWeight={500}
          color={"#fff"}
          padding={{ xs: "8% 0%", sm: "2% 0%" }}
          textAlign={"center"}
        >
          Flip each award to view more information
        </Typography>
      </Grid>
      <Women />
      <Community />
      <Disability />
      <Solution />
      <Civic />
      <Health />
      <Climate />
      <Transparency />
      <Corporate />
      <Box
        padding={"2% 2% 1% 1%"}
        width={"100%"}
        display={"flex"}
        justifyContent={"center"}
      >
        <ColorButton2
          component={"a"}
          variant="outlined"
          size="medium"
          href={"/award-categories"}
          endIcon={
            <ArrowRightAltIcon
              sx={{
                color: "#fff",
                height: "32px",
                width: "32px",
                "&:hover": {
                  color: "#049593",
                },
              }}
            />
          }
        >
          More Categories
        </ColorButton2>
      </Box>
    </Grid>
  );
};

export default Categories;
